import React from "react";
import { fmtCoins } from "../lib/coins";

/**
 * THE single Ponesi Coin asset of the whole customer app — the approved Ponesi Coins artwork
 * (`/brand/ponesi-coin-64|128.png`, derived from `public/brand/source/ponesi-coin.webp`, transparent
 * canvas, 512px source so it stays crisp at 14–24px and on 2x/3x screens). Every coin surface
 * (prices, wallet, checkout, progress, totals, tracking, history) renders through this component,
 * so replacing the artwork here updates the entire app in one place.
 */
export function PonesiCoinIcon({ size = 16, className = "", label = "Ponesi Coins", ...rest }) {
  return (
    <img src="/brand/ponesi-coin-128.png?v=9"
      srcSet="/brand/ponesi-coin-64.png?v=9 1x, /brand/ponesi-coin-128.png?v=9 2x"
      width={size} height={size} alt={label} title={label || undefined}
      role={label ? "img" : "presentation"} aria-hidden={label ? undefined : "true"} draggable="false"
      className={`inline-block shrink-0 align-[-0.15em] select-none ${className}`}
      style={{ width: size, height: size }} {...rest} />
  );
}

/** Icon + amount, always kept on one line. Screen readers hear "<n> Ponesi Coins". */
export function CoinAmount({ value, size = 16, locale = "sr", className = "", iconClassName = "", ...rest }) {
  return (
    <span className={`inline-flex items-center gap-1 whitespace-nowrap ${className}`} {...rest}>
      <PonesiCoinIcon size={size} className={iconClassName} label="" />
      <span>{fmtCoins(value, locale)}</span>
      <span className="sr-only"> Ponesi Coins</span>
    </span>
  );
}
